import { ca } from '@cian/analytics';

export function trackChangeSortEvent(newSortValue: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'sorting',
    label: getTrackingMapSortName(newSortValue),
  });
}

function getTrackingMapSortName(name: string) {
  const map: {
    [index: string]: string;
  } = {
    price_object_order: 'price',
    price_square_order: 'price_per_metr',
    walking_time: 'time_to_metro_area',
  };

  return map[name] || name || 'default';
}

export function trackSortingOpen() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'sorting_open',
    label: '',
    useLastProducts: true,
  });
}
